import { createContext } from "react"
import { AtribuirBairrosInicial } from "../models/atribuirBairrosModel"
import type { AtribuirBairrosModel, BairroAtendido } from "../models/atribuirBairrosModel"
import type { AtribuirBairrosActionModel } from "./atribuirBairrosActions"
import type { AtualizarTaxaPayload } from "../../../services/atribuirBairros"

type AtribuirBairrosContextProps = {
    dados: AtribuirBairrosModel
    dispatch: React.Dispatch<AtribuirBairrosActionModel>
    adicionarBairros: () => Promise<void>
    removerBairro: (id: number) => Promise<void>
    atualizarTaxa: (id: number, payload: AtualizarTaxaPayload) => Promise<BairroAtendido>
    adicionarCidade: (idCidade: number) => Promise<void>
    removerCidade: (idCidade: number) => Promise<void>
    carregarBairros: (idCidade: number | null) => Promise<void>
    erroCarregamento: string | null
}

const initialContextValue: AtribuirBairrosContextProps = {
    dados: AtribuirBairrosInicial,
    dispatch: () => {},
    adicionarBairros: async () => {},
    removerBairro: async () => {},
    atualizarTaxa: async () => { throw new Error("não inicializado") },
    adicionarCidade: async () => {},
    removerCidade: async () => {},
    carregarBairros: async () => {},
    erroCarregamento: null,
}

export const AtribuirBairrosContext =
    createContext<AtribuirBairrosContextProps>(initialContextValue)
